const OPT_OUT_SETTING = 'opted_out_of_all_emails';
export { OPT_OUT_SETTING };
